import { __assign } from "tslib";
import { RandomGenerator } from '../../../test-utils';
var IntegrationBuilder = /** @class */ (function () {
    function IntegrationBuilder() {
        this.integration = {
            id: RandomGenerator.randomId(),
            name: RandomGenerator.randomName(),
            description: 'this integrates bob',
            issuedBy: 'Bob inc',
            iconUrl: 'https://picsum.photos/200',
            creationDate: 1534750882,
            lastUpdateDate: 1534750892,
            settingsUrl: 'https://apps.wix.com/answers-wix-integration/external/salesforce/settings',
            webhooks: {
                REPLY_CREATED: 'https://google.com'
            }
        };
    }
    IntegrationBuilder.prototype.withId = function (id) {
        this.integration.id = id;
        return this;
    };
    IntegrationBuilder.prototype.withName = function (name) {
        this.integration.name = name;
        return this;
    };
    IntegrationBuilder.prototype.withDescription = function (description) {
        this.integration.description = description;
        return this;
    };
    IntegrationBuilder.prototype.withIssuedBy = function (issuedBy) {
        this.integration.issuedBy = issuedBy;
        return this;
    };
    IntegrationBuilder.prototype.withWebhooks = function (webhooks) {
        this.integration.webhooks = webhooks;
        return this;
    };
    IntegrationBuilder.prototype.build = function () {
        return this.integration;
    };
    return IntegrationBuilder;
}());
export { IntegrationBuilder };
// tslint:disable-next-line: max-classes-per-file
var InstalledIntegrationBuilder = /** @class */ (function () {
    function InstalledIntegrationBuilder() {
        this.installedIntegration = __assign(__assign({}, new IntegrationBuilder().build()), { installedDate: 1534750082, setupComplete: false });
    }
    InstalledIntegrationBuilder.prototype.withId = function (id) {
        this.installedIntegration.id = id;
        return this;
    };
    InstalledIntegrationBuilder.prototype.withName = function (name) {
        this.installedIntegration.name = name;
        return this;
    };
    InstalledIntegrationBuilder.prototype.withDescription = function (description) {
        this.installedIntegration.description = description;
        return this;
    };
    InstalledIntegrationBuilder.prototype.withIssuedBy = function (issuedBy) {
        this.installedIntegration.issuedBy = issuedBy;
        return this;
    };
    InstalledIntegrationBuilder.prototype.withWebhooks = function (webhooks) {
        this.installedIntegration.webhooks = webhooks;
        return this;
    };
    InstalledIntegrationBuilder.prototype.withSetupComplete = function (setupComplete) {
        this.installedIntegration.setupComplete = setupComplete;
        return this;
    };
    InstalledIntegrationBuilder.prototype.build = function () {
        return this.installedIntegration;
    };
    return InstalledIntegrationBuilder;
}());
export { InstalledIntegrationBuilder };
//# sourceMappingURL=builders.js.map